import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectAdobeAnalyticsPage = lazy(
  () => import('~/features/onboarding/pages/connect-adobe-analytics-screen'),
);

/** `connectionId` present → edit an existing Adobe connection (prefill + PATCH);
 *  absent → the normal create flow. */
const searchSchema = z.object({
  connectionId: z.string().optional(),
});

function ConnectAdobeAnalyticsRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectAdobeAnalyticsPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/adobe-analytics/',
)({
  validateSearch: searchSchema,
  component: ConnectAdobeAnalyticsRouteComponent,
});
